import { render, staticRenderFns } from "./DownloadExpiredSVG.vue?vue&type=template&id=dddcc512&"
import script from "./DownloadExpiredSVG.vue?vue&type=script&lang=js&"
export * from "./DownloadExpiredSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports